import { Dispatch, memo, SetStateAction } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  FullscreenControl,
  GeolocationControl,
  Map,
  Placemark,
  RulerControl,
  SearchControl,
  TrafficControl,
  TypeSelector,
  YMaps,
  ZoomControl,
} from '@pbe/react-yandex-maps';
import { ModalState } from '../../models';
import {
  ModalContentWrapper,
  ModalTitle,
  ModalTitleWrapper,
} from '../common/Modal';
import { DEVICE_SCREENS_MAX_STRING } from '../../lib/consts';

function YaMapModalMemo({
  cords,
  setModalState,
}: {
  cords: string;
  setModalState: Dispatch<SetStateAction<ModalState>>;
}) {
  const position = cords.split(' ').reverse();
  return (
    <ModalContentWrapper>
      <ModalTitleWrapper setModalState={setModalState}>
        <ModalTitle>Карта</ModalTitle>
      </ModalTitleWrapper>
      <div>
        <YMaps>
          <Map
            state={{
              center: [Number(position[0]), Number(position[1])],
              zoom: 14,
            }}
            css={{
              width: '100%',
              height: '400px',
              [DEVICE_SCREENS_MAX_STRING.md]: {
                height: 'calc(100vh - 70px)',
              },
            }}
          >
            <Placemark
              options={{ preset: 'islands#redDotIcon' }}
              geometry={position}
            />
            <GeolocationControl options={{ float: 'left' }} />
            <SearchControl options={{ float: 'left' }} />
            <ZoomControl />
            <RulerControl />
            <TypeSelector />
            <TrafficControl />
            <FullscreenControl />
          </Map>
        </YMaps>
      </div>
    </ModalContentWrapper>
  );
}

export const YaMapModal = memo(
  YaMapModalMemo,
  (oldProps, newProps) => oldProps.cords !== newProps.cords
);
